import type { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'
import type { EngagementTypeComponentEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-type-component.enum'
import type { EngagementToolEnum } from '../../enums'
import type { AuditItemPayload } from '../../models'
import type { AuditService } from '../../services'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'

export interface AuditActionParams {
  action: EngagementActionsTypeEnum | EngagementTypeComponentEnum
  tool: EngagementToolEnum
  params: { date: string; index: string[]; payload: AuditItemPayload; user: string }
}

export interface AuditComposable {
  auditAction: ({ action, tool, params }: AuditActionParams) => Promise<void>
}

export const useAudit = (): AuditComposable => {
  const auditAction = async ({ action, tool, params }: AuditActionParams): Promise<void> => {
    const auditService = CONTAINER.get<AuditService>(TYPES.AuditService)
    try {
      await auditService.auditAction({
        action,
        tool,
        params,
      })
    } catch (error) {
      console.log('Error auditing action', error)
    }
  }

  return {
    auditAction,
  }
}
